import {  Tabs } from 'antd';
import { Select } from 'antd';
import CarrierComplianceSettings from './CarrierComplianceSettings';
import TextingTab from './TextingTab';
const { Option } = Select;

const TextingSettings = () => {

    const onChange = (key) => {
        console.log(key);
    };
    const items = [
        {
            key: '1',
            label: `Texting Settings`,
            children: <TextingTab />,
        },
        {
            key: '2',
            label: `Carrier Compliance Settings`,
            children: <CarrierComplianceSettings />,
        }

    ];
    return (
        <div className="page-container">
        <div className="main-container">
        
            <Tabs  defaultActiveKey="1" items={items} onChange={onChange} />
        </div>
        </div>
    )
}

export default TextingSettings;


